/**
 * Ads-tab slice of the English catalog (task 85 carve-out).
 *
 * en.ts sits against the 500-line fileSize ceiling, and task 85's vocabulary of
 * ABSENCE — the copy that says "we don't know" where the tab used to print a
 * zero — did not fit. Add new ads.* keys HERE, spread back into `en` in en.ts;
 * t() and MessageKey are unchanged.
 */
export const enAds = {
  'ads.heading': 'Campaign Performance',
  'ads.audienceNotApplicable':
    "The audience filter doesn't apply here — ad campaigns aren't broken down by customer segment.",
  'ads.reconnectMeta': 'Reconnect Meta with Ads access',

  // ── Noun labels (kind-alignment §8) ───────────────────────────────────
  'ads.conversionsDefault': 'Conversions',
  'ads.conversionsNoun': '{noun}s',
  'ads.revenueDefault': 'Total Revenue',
  'ads.revenueNoun': '{noun} revenue',

  'ads.subtitle': 'Meta and Google Ads performance tied to your {noun}s.',
  // Rule-based (ROAS and CTR thresholds in AdsTab/utils.ts), not AI:
  // BuzzBit X runs no AI of its own. Marketing to review wording.
  'ads.colAiAction': 'Suggested action',
  'ads.colCampaign': 'Campaign',
  'ads.colStatus': 'Status',
  'ads.colBudget': 'Budget',
  'ads.colSpend': 'Spend',
  'ads.colImpressions': 'Impressions',
  'ads.colReach': 'Reach',
  'ads.colClicks': 'Clicks',
  'ads.colCtr': 'CTR',
  'ads.colCpa': 'CPA',
  'ads.colRevenue': 'Revenue',
  'ads.colRoas': 'ROAS',
  'ads.kpiActiveCampaigns': 'Active Campaigns',
  'ads.kpiTotalSpend': 'Total Spend',
  'ads.kpiRoas': 'ROAS',
  'ads.kpiAvgCtr': 'Avg CTR',
  'ads.kpiReach': 'People reached',
  'ads.kpiFrequency': 'Frequency',
  'ads.kpiFrequencyHint': 'How many times, on average, each person saw an ad. Meta reports reach; Google Ads does not, so its campaigns are left out of this pair.',
  'ads.loading': 'Loading campaigns...',
  'ads.emptyTitle': 'No ad campaigns yet',
  'ads.emptyBody':
    'Connect Meta or Google Ads with the buttons above and your campaign performance will appear here automatically.',
  'ads.emptyCta': 'Open Integrations',
  // Task 85 — the vocabulary of absence. Kept plain: a merchant needs to know
  // the number is missing, not why our request failed.
  'ads.unmeasured': 'No data',
  'ads.unmeasuredHint':
    "This campaign's numbers haven't come back from the ad platform yet, so we're not showing figures we can't stand behind. Run a sync to fetch them.",
  'ads.unavailableTitle': "We couldn't load your campaigns",
  'ads.unavailableBody':
    "This isn't the same as having none — the request didn't come back. Try again in a moment, or run a sync.",
  'ads.partialTotals':
    "Totals cover only the campaigns we have figures for. {count} campaign(s) haven't reported yet and are left out.",
  'ads.actionNoData': 'No data',
  'ads.actionScale': 'Scale +20%',
  'ads.actionKill': 'Kill Campaign',
  'ads.actionCreative': 'Update Creative',
  'ads.actionMonitor': 'Monitor',

  // ── Managed campaign review (W3): the human half of the AI draft chain ──
  'ads.managed.heading': 'Managed campaigns — review',
  'ads.managed.explain':
    'Drafts the assistant prepares land here switched off. Publishing creates them PAUSED on the ad platform; only Activate starts spend, and only you can press it.',
  'ads.managed.empty': 'Nothing awaiting review.',
  'ads.managed.approve': 'Approve draft',
  'ads.managed.publish': 'Publish (stays paused)',
  'ads.managed.activate': 'Activate — starts spending',
  'ads.managed.statusDraft': 'Draft — local only',
  'ads.managed.statusApproved': 'Approved — not on the platform yet',
  'ads.managed.statusPaused': 'On the platform, paused',
  'ads.managed.statusActive': 'ACTIVE — spending',
  'ads.managed.actionFailed': 'That did not go through. Check the spend guard and try again.',
} as const;
